import {actions as A} from '../constants/actions';

export const setPage = page => dispatch => {
  dispatch({
    type: A.SET_INSPECTIONS_BY_FIRM_PAGE,
    payload: {page}
  });
};
